var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SidebarZones',{attrs:{"visualizationMode":_vm.visualizationMode}})
}
var staticRenderFns = []

export { render, staticRenderFns }